module.exports = __webpack_public_path__ + "static/media/NMember.386c8829.png";